import { useForm } from '@mantine/form';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { UpdateUserConsentsDto } from 'src/Services/API/generated';

export interface AcceptTermsFormValues {
  acceptedTermsPrivacy: boolean;
  newsletterOptIn: boolean;
}

export const useAcceptTermsForm = () => {
  const { t } = useTranslation();

  return useForm<AcceptTermsFormValues, (value: AcceptTermsFormValues) => UpdateUserConsentsDto>({
    initialValues: {
      acceptedTermsPrivacy: false,
      newsletterOptIn: false,
    },
    validate: {
      acceptedTermsPrivacy: value =>
        value
          ? null
          : t('forms.needAcceptTerms', "Vous devez accepter les conditions d'utilisation"),
    },
    transformValues: values => {
      return {
        ...values,
        acceptedTermsPrivacyVersion:
          import.meta.env.VITE_TERMS_PRIVACY_VERSION ?? `unknown version ${dayjs().toISOString()}`,
      };
    },
  });
};
